import React from "react";
import { MoviePosterEditor } from "../base/MoviePosterEditor";
import { FILM_CONFIG } from "./filmConfig";

function FilmPosterEditor(props) {
  return (
    <MoviePosterEditor
      {...props}
      workshopConfig={{
        ...FILM_CONFIG.poster,
        templateStrings: FILM_CONFIG.dalle.templateStrings,
        templateElements: FILM_CONFIG.dalle.templateElements,
      }}
    />
  );
}

export { FilmPosterEditor };
